var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h5',{staticClass:"intro-paragraph",domProps:{"innerHTML":_vm._s(_vm.$t(_vm.content))}})
}
var staticRenderFns = []

export { render, staticRenderFns }